require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-new-code-401-course-focuses-on-asp-net-core-microsofts-open-source-framework.json") })
        }
      }, "path---blog-new-code-401-course-focuses-on-asp-net-core-microsofts-open-source-framework");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-new-code-401-course-focuses-on-asp-net-core-microsofts-open-source-framework!./.cache/json/blog-new-code-401-course-focuses-on-asp-net-core-microsofts-open-source-framework.json
// module id = 1015
// module chunks = 231608221292675